import { FileNameSeparatorWithExtension } from '@/components/FileNameSeparatorWithExtension';
import { useBusinessDocumentsContext } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/context/BusinessDocumentsContext';
import { ActiveFileType } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/context/PaymentDetailContext';
import { Tag, TextLink } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from '../../styles.module.scss';

const cx = classNames.bind(styles);

type BusinessDocumentsFieldViewProps = Record<string, never>;

export const BusinessDocumentsFieldView: FC<BusinessDocumentsFieldViewProps> =
  memo(() => {
    const { processedDocuments, selectDocumentFile, activeFile } =
      useBusinessDocumentsContext();

    if (processedDocuments?.length === 0) {
      return null;
    }

    return (
      <>
        {processedDocuments?.map((processedDocument) => {
          const isActive =
            activeFile?.type === ActiveFileType.BUSINESS_DOCUMENT &&
            activeFile?.id === processedDocument?.id;

          return (
            <div
              className={cx(
                'linkContainer',
                isActive && 'active' // Add active state class
              )}
              key={
                processedDocument?.mf_file?.id ??
                'empty-view-business-documents-field'
              }
              onClick={selectDocumentFile(processedDocument)}
            >
              <Tag
                className={cx('tagContainer')}
                closable={false}
                status='default'
                icon={false}
                size='default'
              >
                {processedDocument?.label || ''}
              </Tag>
              <TextLink
                key={
                  processedDocument?.mf_file?.id ??
                  'empty-view-business-documents-field'
                }
                href={processedDocument?.href ?? ''}
                target='_blank'
                className={cx('textLinkContainer')}
                onClick={(e) => {
                  e.stopPropagation();
                  selectDocumentFile(processedDocument)();
                }}
              >
                <FileNameSeparatorWithExtension>
                  {processedDocument?.mf_file?.name ?? ''}
                </FileNameSeparatorWithExtension>
                <div className={cx('textLinkContainerExtension')}>
                  <span> {processedDocument?.document_number ?? ''}</span>
                </div>
              </TextLink>
            </div>
          );
        })}
      </>
    );
  });

BusinessDocumentsFieldView.displayName = 'BusinessDocumentsFieldView';
